import React, { createContext, useMemo } from 'react';
import { useEffect, useState } from 'react';
import useDataSource from '../hooks/useDataSource';
import config from '../config/kystverket';

const DataContext = createContext();

const DataContextProvider = ({ children }) => {
  const [searchTitleFormats, setSearchTitleFormats] = useState({});

  const datasetAliases = useMemo(() => {
    return Object.values(config.themes)
      .map(element => {
        if (element.inSearch === false) return null;
        return element.dataset_alias;
      })
      .filter(Boolean);
  }, []);

  useEffect(() => {
    const adaptive4Url = window.KystverketConfig?.adaptive4Url || '';
    async function fetchFormats() {
      const formats = {};
      await Promise.all(
        datasetAliases.map(async alias => {
          try {
            const res = await fetch(
              `${adaptive4Url}api/core/v1/ogc/features/collections/${alias}/schema`
            );
            const data = await res.json();

            if (data && data.exTitleFormat) {
              formats[alias] = data.exTitleFormat;
            }
          } catch (err) {
            console.error(`Failed to fetch schema for alias "${alias}":`, err);
          }
        })
      );
      setSearchTitleFormats(formats);
    }
    fetchFormats();
  }, [datasetAliases]);
  const port = useDataSource({ type: 'port' });
  const portfacility = useDataSource({ type: 'portfacility' });
  const route = useDataSource({ type: 'route' });
  const quay = useDataSource({ type: 'quay' });
  const mtr = useDataSource({ type: 'mtr' });
  const cpr = useDataSource({ type: 'cpr' });
  const svalbard = useDataSource({ type: 'svalbard' });
  const anchorage = useDataSource({ type: 'anchorage' });

  const loading = useMemo(() => {
    return !(
      !port.loading &&
      port.items &&
      !portfacility.loading &&
      portfacility.items &&
      !route.loading &&
      route.items &&
      !quay.loading &&
      quay.items &&
      !mtr.loading &&
      mtr.items &&
      !cpr.loading &&
      cpr.items &&
      !svalbard.loading &&
      svalbard.items &&
      !anchorage.loading &&
      anchorage.items
    );
  }, [
    port.loading,
    port.items,
    portfacility.loading,
    portfacility.items,
    route.loading,
    route.items,
    quay.loading,
    quay.items,
    mtr.loading,
    mtr.items,
    cpr.loading,
    cpr.items,
    svalbard.loading,
    svalbard.items,
    anchorage.loading,
    anchorage.items
  ]);

  const items = useMemo(() => {
    if (!loading) {
      return [
        ...port.items,
        ...portfacility.items,
        ...route.items,
        ...quay.items,
        ...mtr.items,
        ...cpr.items,
        ...svalbard.items,
        ...anchorage.items
      ];
    }
    return [];
  }, [
    loading,
    port.items,
    portfacility.items,
    route.items,
    quay.items,
    mtr.items,
    cpr.items,
    svalbard.items,
    anchorage.items
  ]);

  return (
    <DataContext.Provider
      value={{
        items,
        loading,
        port: port.items,
        portfacility: portfacility.items,
        route: route.items,
        quay: quay.items,
        mtr: mtr.items,
        cpr: cpr.items,
        svalbard: svalbard.items,
        anchorage: anchorage.items,
        searchTitleFormats
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

const DataContextConsumer = DataContext.Consumer;

export { DataContext, DataContextProvider, DataContextConsumer };
